import { http } from '../auth/http';

const REQUEST_TIMEOUT_MS = 20000;
export const STUDIO_BUS_BASE = '/api/studio-bus';

http.defaults.timeout = REQUEST_TIMEOUT_MS;

export const api = http;

export function getApiErrorMessage(error, fallback = 'Request failed') {
  if (error?.response?.data?.detail) {
    return String(error.response.data.detail);
  }
  if (error?.response?.data?.message) {
    return String(error.response.data.message);
  }
  if (error?.code === 'ECONNABORTED') {
    return 'Request timed out';
  }
  if (error?.message) {
    return String(error.message);
  }
  return fallback;
}
